export default {
  selectedState(state: any, value: any) {
    // console.log("updating state in store", value);
    state.selectedState = value;
    // console.log(state.selectedState);
  },

  selectedCategory(state: any, value: any) {
    // console.log("updating category in store", value);
    state.selectedCategory = value;
    // console.log(state.selectedCategory);
  },

  setResultsLoading(state: any, value: any) {
    // console.log(`state.searchResultsLoading = ${value}`)
    state.searchResultsLoading = value
  },

  setSearchResults(state: any, values: any) {
    // console.log("updating search results list");
    state.searchResults.page = 1
    state.searchResults.items = values
  },

  setPlaceDetailsLoading(state: any, value: any) {
    state.placeDetailsLoading = value
  },

  setFetchedPlaceDetails(state: any, value: any) {
    state.fetchedPlaceDetails = value
  },

  setFAQData(state: any, value: any) {
    state.fetchedFAQ = value
  },

  setFAQLoading(state: any, value: any) {
    state.isFAQLoading = value
  },

  registerFormSubmitting(state: any, value: any) {
    state.registerFormSubmitting = value
  },

  registerFormSubmitResult(state: any, value: any) {
    state.registerFormSubmitResult = value
  },

  messageFormSubmitting(state: any, value: any) {
    state.messageFormSubmitting = value
  },

  messageFormSubmitResult(state: any, value: any) {
    state.messageFormSubmitResult = value
  }
}
